import {Injectable, OnInit} from '@angular/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {DataService} from './data.service';
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import Auth = firebase.auth.Auth;
import {Observable} from "rxjs";
import {QuerySnapshot} from "@angular/fire/compat/firestore";
import {UserInfo} from "../models/userInfo";
import {firstValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnInit{

  currentUserEmail?: string
  currentUser?: firebase.User
  loggedIn = false
  isAdmin = false

  constructor(
    public afAuth: AngularFireAuth,
    public dataService: DataService
  ) {
    this.getAuth().onAuthStateChanged((user) => {
      console.log('authStateChanged', user)
      if (user) {
        this.currentUser = user
        if (user.email) this.currentUserEmail = user.email
        this.onLogin()
      } else {
        this.currentUserEmail = 'Přihlásit'
        this.onLogout()
      }
    })

  }

  getAuth() {
    return this.afAuth
  }

  async ngOnInit() {
  }

  async passwordLogin() {
    const currentUser = await this.getAuth().currentUser
    if (currentUser?.email) {
      this.currentUserEmail = currentUser.email
    }
		this.onLogin()
	}

  async createUserWithEmailAndPassword(email: string, password: string, name: string, firstName: string, lastName: string) {
    try {
      const result = await this.afAuth.createUserWithEmailAndPassword(email, password)
      if (result.user) {
        await this.dataService.userInfoCollectionRef.doc(result.user.uid).set({
          email,
          name,
          firstName,
          lastName,
          isAdmin: false 
        })
      }
      return result
    } catch (error) {
      throw error
    }
  }

  async signInWithEmailAndPassword(email: string, password: string) {
    await this.getAuth().setPersistence(Auth.Persistence.LOCAL)
    return await this.getAuth().signInWithEmailAndPassword(email, password)
  }

  async signup(email: string, password: string, name: string, firstName: string, lastName: string) {
    try {
  		const credential = await this.createUserWithEmailAndPassword(email, password, name, firstName, lastName)
      await this.signInWithEmailAndPassword(email, password)
    } catch (error: any) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.error(errorCode, errorMessage)
		}
	}

  async logout() {
		await this.getAuth().signOut()
		this.onLogout()
	}

  async onLogin() {
    this.loggedIn = true
    // Fetch user info from Firestore to determine admin status
    if (this.currentUserEmail) {
      try {
        const userSnapshot = await firstValueFrom(
          this.dataService.getUserInfo(this.currentUserEmail)
        );
        
        if (!userSnapshot.empty) {
          const userData = userSnapshot.docs[0].data();
          this.isAdmin = userData.isAdmin || false;
        } else {
          this.isAdmin = false;
        }
      } catch (error) {
        console.error('Error fetching user info:', error);
        this.isAdmin = false;
      }
    } else {
      this.isAdmin = false;
    }
  }

  onLogout() {
    this.loggedIn = false
    this.isAdmin = false
  }

  isLoggedIn() {
    return this.loggedIn
  }

  getCurrentUser() {
    return this.currentUser
  }

  getCurrentUserNickname(): Observable<QuerySnapshot<UserInfo>> | undefined {
    if (this.currentUserEmail) {
      return this.dataService.getUserInfo(this.currentUserEmail)
    }
    return undefined
  }

  resetPassword(email: string) {
    return this.getAuth().sendPasswordResetEmail(email)
  }

  async updatePassword(currentPassword: string, newPassword: string) {
    const user = await this.getAuth().currentUser;
    if (!user || !user.email) {
      throw new Error('Uživatel není přihlášen');
    }

    // Reauthenticate user before changing password
    const credential = firebase.auth.EmailAuthProvider.credential(
      user.email,
      currentPassword
    );
    
    await user.reauthenticateWithCredential(credential);
    await user.updatePassword(newPassword);
  }
}
